import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Prompt, matchPath, useLocation } from 'react-router';
function UnsavedChangesPrompt(_ref) {
  var hasUnsavedChanges = _ref.hasUnsavedChanges,
    _ref$permissablePaths = _ref.permissablePaths,
    permissablePaths = _ref$permissablePaths === void 0 ? [] : _ref$permissablePaths,
    _ref$includeQueryPara = _ref.includeQueryParams,
    includeQueryParams = _ref$includeQueryPara === void 0 ? false : _ref$includeQueryPara;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  // `location.pathname` ensures that changes of query parameters
  // on the same page are allowed and don't trigger a prompt
  var paths = includeQueryParams ? _toConsumableArray(permissablePaths) : [].concat(_toConsumableArray(permissablePaths), [location.pathname]);
  return /*#__PURE__*/React.createElement(Prompt, {
    when: hasUnsavedChanges,
    message: function message(nextLocation) {
      if (paths.some(function (path) {
        return matchPath(nextLocation.pathname, {
          path: path,
          exact: true
        });
      })) {
        return true;
      }
      return t('modal_confirm_quit_edit_without_save');
    }
  });
}
export default UnsavedChangesPrompt;